import { consume } from '@lit/context'
import { css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import type { EPNavListContext } from './ep-nav-list'
import { context } from './ep-nav-list'
import { LitHauntedElement } from '../../mixins/lit-haunted-element'
import { useEffect } from 'haunted'

@customElement('ep-nav-list-search')
export class EPNavListSearch extends LitHauntedElement {

  @consume({ context: context, subscribe: true })
  @property({ attribute: false })
  provider?: EPNavListContext;

  @property({ type: Boolean, reflect: true })
  disabled: boolean = false;

  @property({ attribute: false })
  filterText: string = '';

  @property({ attribute: 'filter-selector', reflect: true })
  filterSelector: keyof HTMLElementTagNameMap = 'ep-nav-list-item'

  render() {
    useEffect(() => this._handleSearch(), [this.filterText])

    return html`
      <li part="content"
        data-appearance=${'normal'}
        data-variant=${'button'}
        data-disabled=${this.disabled}>
        <fluent-text-field appearance="outline" placeholder="Search..." .value=${this.filterText} @input=${this._handleTextInput}>
        </fluent-text-field>
      </li>
    `
  }

  private _handleTextInput(event: InputEvent) {
    const target = event.target as HTMLInputElement;
    this.filterText = target.value;
  }

  private _handleSearch() {
    const root = this.provider?.rootNavList
    if (root !== undefined) {
      const items = Array.from(this.provider?.rootNavList.querySelectorAll(this.filterSelector) ?? []) as HTMLElement[];
    
      const satisfies = (e: HTMLElement) => e.textContent?.toLowerCase().includes(this.filterText.toLowerCase()) ?? false;
      const HAS_NO_RESULTS = items.every(e => !satisfies(e));
      const noResultIndicators: HTMLElement[] = (root.emptySlotElement?.assignedElements() ?? []).filter(e => e instanceof HTMLElement) as any;

      for(let item of noResultIndicators) {
        item.style.display = HAS_NO_RESULTS ? 'block' : 'none';
      }
      
      for(let item of items) {
        if (satisfies(item)) {
          item.style.removeProperty('display')
        }
        else {
          item.style.display = 'none';
          // TODO: parents
        }
      }
    }
  }

  static styles = css`
    :host {
      --font-prose: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
      /* --color: var(--color-plain); */
      --indent-count-item: 0;
      --color-plain: rgb(36, 41, 47);
      --color-destructive: rgb(207, 34, 46);
      --padding: 8px;
      --height: calc(32px + 2 * var(--padding));
      color: var(--color, var(--color-plain));
      display: block;
      position: sticky;
      top: -8px; /* because of the <ep-nav-list> top padding */
      height: var(--height);
      z-index: 5;
    }

    * {
      box-sizing: border-box;
    }

    li {
      position: relative;
      display: flex;
      padding: 0px;
      font-size: 14px;
      line-height: 20px;
      min-height: 5px;
      margin-left: 8px;
      margin-right: 8px;
      border-radius: 6px;
      transition: background 33.333ms linear 0s;
      color: var(--color);
      cursor: default;
      appearance: none;
      background: unset;
      border: unset;
      /* width: calc(100% - 16px); */
      width: 100%;
      font-family: unset;
      font-weight: normal;
      text-align: unset;
      margin-top: unset;
      margin-bottom: unset;
    }

    li {
      padding: 8px;
      margin: 0;
      background: #fbfbfb;
      /* background-color: rgb(229, 233, 233); */
      /* background: rgba(255,255,255,0.75);
      backdrop-filter: blur(5px); */
    }

    fluent-text-field {
      flex: 1;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-nav-list-search': EPNavListSearch
  }
}
